import VBottomSheet from './VBottomSheet'

/* istanbul ignore next */
VBottomSheet.install = function install (Vue) {
  Vue.component(VBottomSheet.name, VBottomSheet)
}

export { VBottomSheet }
export default VBottomSheet
